import { appCounterStore } from "@/store/app";
import { useCounterStore } from "@/store/user";
import router from "@/router";
const store = appCounterStore();
const useStore = useCounterStore();
export const useLogin = () => {
    const changeState = (str) => {
        store.setLoginState(str);
    };
    const goLogin = async () => {
        store.setLoginState("login");
        await useStore.resetToken();
    };
    const goModify = () => {
        router.push({ path: "/modifyPassword" });
    };
    return {
        changeState,
        goLogin,
        goModify
    };
};
